module.exports = __webpack_public_path__ + "img/portal-2002.d0016150.jpg";